import { Get } from '../helpers';

const GetGlobalTemplateTypes = async (): Promise<string[]> => {
  return Get({
    path: `/v3/admin/events/global-template-types`,
  });
};

export default GetGlobalTemplateTypes;
